import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import {
  ToolbarPopoverChoiceRow,
  ToolbarPopoverSwitchRow,
  type ToolbarPopoverChoiceOption,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.popover";
import {
  PrimaryControlsStripExpansionDisplayPushButton,
  type PrimaryControlsStripExpansionDisplayPushButtonProps,
} from "@-/dev.improve.haniverse.routes.nav.app._components.primary-controls-strip.expansion.push-button.display";
import {
  BrowseWordsPageContext,
  type WordTileFront,
} from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._context";

const TILE_FRONT_OPTIONS: readonly ToolbarPopoverChoiceOption<WordTileFront>[] = [
  { label: "Glyphs", testID: "words-display-tiles-glyphs", value: "glyphs" },
  { label: "Pinyin", testID: "words-display-tiles-pinyin", value: "pinyin" },
];

/**
 * Shared Display popover for the Words page — session tone colors / script, the page-local choice
 * of whether each word tile shows written glyphs or its readings, and (on the HSK view) whether
 * one-glyph HSK entries appear in the grid.
 */
export function BrowseWordsDisplayPushButton(
  pushButtonProps: Omit<PrimaryControlsStripExpansionDisplayPushButtonProps, "children">,
) {
  const [
    wordTileFront,
    setWordTileFront,
    sortMode,
    showSingleCharacterWords,
    setShowSingleCharacterWords,
  ] = useContextSelectors(
    BrowseWordsPageContext,
    (c) => c.wordTileFront,
    (c) => c.setWordTileFront,
    (c) => c.sortMode,
    (c) => c.showSingleCharacterWords,
    (c) => c.setShowSingleCharacterWords,
  );

  return (
    <PrimaryControlsStripExpansionDisplayPushButton {...pushButtonProps}>
      <ToolbarPopoverChoiceRow
        label="Tiles"
        onValueChange={setWordTileFront}
        options={TILE_FRONT_OPTIONS}
        value={wordTileFront}
      />
      {sortMode === "hsk" ? (
        <ToolbarPopoverSwitchRow
          checked={showSingleCharacterWords}
          label="Show single-character words"
          onCheckedChange={setShowSingleCharacterWords}
          testID="words-display-show-single-character"
        />
      ) : null}
    </PrimaryControlsStripExpansionDisplayPushButton>
  );
}
